"use strict";
/**
 * @module Services.TopicUpdate
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Write a {@link Unconstrained} update constraint to the stream
 */
function write() {
    // no-op, write nothing
}
exports.write = write;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-update/unconstrained-serialiser.js
// module id = 1429
// module chunks = 1